import React, { Component } from 'react'

// This component has:
// 1. Announcement message
// 2. Takes state from above to show/hide

import IconSquare from './icons/IconSquare'

class Announcement extends Component {

   componentDidMount() {
   }

   render() {
      const {
        message = 'Lecture tonight by Ms. Keiko Ogura at Gifford Audtiorium, Huntington Beard Crouse Hall from 4:30–6pm',
        show = true
      } = this.props.data

      const showClass = (show) ? 'announcement-show' : 'announcement-hide'

      return (
         <div className={`Announcement ${showClass}`}>

           <div className="announcement-message center">
             <IconSquare size="10px" color="black"/>&nbsp;&nbsp;&nbsp;{message}&nbsp;&nbsp;&nbsp;<IconSquare size="10px" color="black"/>
           </div>

         </div>
      )
   }
}

export default Announcement



// WEBPACK FOOTER //
// ./src/components/Announcement.js